'use client';

import { Trans } from '@lingui/macro';
import { Box, Stack } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { type FC, type ReactNode, useCallback, useState } from 'react';

type Item = {
  id: string;
  render: ReactNode;
  defaultVisibility: boolean;
};

type Props = {
  list: Item[];
};

export const SkillsListHideWrapper: FC<Props> = (props) => {
  const { list } = props;

  const [wantToSeeMore, setWantToSeeMore] = useState<boolean>(false);

  const onToggleWantToSeeMore = useCallback(() => {
    setWantToSeeMore((prev) => !prev);
  }, [setWantToSeeMore]);

  return (
    <Stack direction="column" flexWrap="wrap" spacing={3}>
      {list
        .filter((item) => item.defaultVisibility || wantToSeeMore)
        .map((item) => (
          <Box component="div" key={item.id}>
            {item.render}
          </Box>
        ))}

      <Stack direction="row" justifyContent="center">
        <Button onClick={onToggleWantToSeeMore} variant="text" color="inherit">
          {wantToSeeMore ? (
            <Trans>Cacher une partie de la hiérarchie</Trans>
          ) : (
            <Trans>Afficher toute la hiérarchie</Trans>
          )}
        </Button>
      </Stack>
    </Stack>
  );
};
